import { FlexColumn, FlexRow, LabeledData } from '@gorila-shared-ui/components';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { useDevice } from '../../hooks/useDevices';
import { useStyles } from '../../hooks/useStyles';
import { Device } from '../../types/device';
import DeviceCurrentStateWrapper from './DeviceCurrentStateWrapper';

type Props = Readonly<{
  device: Device;
}>;

export function DeviceInfo({ device }: Props) {
  const { css, theme } = useStyles();
  const { isSmall } = useBreakpoints();
  const { getDeviceCarrierLabel } = useDevice();

  return (
    <FlexColumn classNames={css({ flex: 1 })}>
      <FlexColumn>
        <FlexRow
          classNames={css({
            flexDirection: isSmall ? 'column' : 'row',
          })}
        >
          <FlexColumn
            gap={theme.sizing.scale300}
            classNames={css({ flex: 1 })}
          >
            <LabeledData
              label="Modelo:"
              content={device.model.name}
            />
            <LabeledData
              label="Marca:"
              content={device.brand.name}
            />
            {device.asset?.client && (
              <LabeledData
                label="Cliente:"
                content={device.asset.client.name}
              />
            )}
            {device.asset?.subClient && (
              <LabeledData
                label="Subcliente:"
                content={device.asset.subClient.name}
              />
            )}
            {device.imei && (
              <LabeledData
                label="IMEI:"
                content={device.imei}
              />
            )}
            {device.sim && (
              <LabeledData
                label="SIM:"
                content={device.sim}
              />
            )}
            {device.carrier && (
              <LabeledData
                label="Carrier:"
                content={getDeviceCarrierLabel(device.carrier)}
              />
            )}
          </FlexColumn>
        </FlexRow>
        <DeviceCurrentStateWrapper device={device} />
      </FlexColumn>
    </FlexColumn>
  );
}
